import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Loader } from 'components/Loader/Loader';
import { ReqEnum } from 'const/requestStatus';
import dayjs, { Dayjs } from 'dayjs';
import { useFetchCouriersScore } from '../../hooks/useFetchCouriersScore';
import { CourierScoreList } from './CourierScoreList';
import { CalendarFetchByDay } from '../../components/OrderListTable/CalendarFetch/CalendarFetchByDay';
import './MyRating.scss';
import { Link } from 'react-router-dom';

function showDayByHourOfDay(): Dayjs {
  const timeNow = dayjs(new Date());
  const shiftStartsIsh = 17;

  if (timeNow.isBefore(dayjs(new Date()).set('hour', shiftStartsIsh))) {
    const yesterDay = dayjs(timeNow).set('h', -24);
    return yesterDay;
  } else {
    return timeNow;
  }
}

export function MyRating(): JSX.Element {
  const dayToSHow: Dayjs = showDayByHourOfDay();
  const [startDate, setStartDate] = useState(dayToSHow);

  const [couriersScore, fetchCourierScoreStatus] = useFetchCouriersScore(
    dayjs(startDate).format('YYYY-MM-DD'),
    dayjs(startDate).format('YYYY-MM-DD')
  );

  const fetchValues = (givenDate: Dayjs) => {
    setStartDate(givenDate);
  };

  return (
    <>
      <Helmet>
        <title>{'My Rating'}</title>
      </Helmet>
      <div className="MyRating">
        <CalendarFetchByDay
          fetchValues={fetchValues}
          givenDate={startDate}
          trackingName={'myRating-courier'}
        />
        {startDate.isAfter(new Date('2021-09-14'), 'day') ? (
          <p
            style={{ textAlign: 'center', marginTop: '30vh', fontSize: '20px' }}
          >
            This rating page is valid for period before 15th September, 2021.
            Please change period accordingly to see older data, or use the{' '}
            <Link to="/my-rating">new my rating page</Link>.
          </p>
        ) : fetchCourierScoreStatus === ReqEnum.PENDING ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Loader type="spinner" size="large" />
          </div>
        ) : (
          <>
            <div className="MyRatingListPosition">
              <CourierScoreList couriersScore={couriersScore} />
            </div>
          </>
        )}
      </div>
    </>
  );
}
